import {v4 as uuidv4} from 'uuid';
import {ContentHomeOverviewVo} from '../../common/shared/api/nicolas/vo/ContentHomeOverviewVo.interface';
import {ContentHomeOverview} from '../generated/types';
import {createDisplayAd} from './DisplayAd';
import {createNormalListViewItem} from './NormalListViewItem';
import {createSeries} from './Series';

export function createContentHomeOverview({
  content,
  set_list,
  display_ad,
  last_notice_date,
  page_continue,
  related_series,
}: ContentHomeOverviewVo): ContentHomeOverview {
  return {
    id: uuidv4(),
    seriesId: content.series_id,
    content: createSeries(content, {
      fallback_page_continue: page_continue,
      useStonKageUrl: true,
      thumbnailResolution: 'o1',
    }),
    setList: set_list?.map(set =>
      createNormalListViewItem({}, {contentSetDto: set})
    ),
    displayAd: display_ad && createDisplayAd(display_ad),
    lastNoticeDate: last_notice_date,
    relatedSeries: related_series?.item && createSeries(related_series.item),
  };
}
